import React, { useEffect, useState, useRef } from "react";
import { Button, FormItem, FormContainer, Alert } from "components/ui";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import OtpInput from "react-otp-input";
import "react-phone-number-input/style.css";
import { ActionLink } from "components/shared";
// import googleIco from "../../../assets/image/google.svg";
import { useSelector } from "react-redux";
import { useUserAuth } from "context/userAuthContext";
import axiosInstance from "apiServices/axiosInstance";
import openNotification from "views/common/notification";
import useAuth from "utils/hooks/useAuth";
import appConfig from "configs/app.config";
import { Box } from "@mui/material";
import GoogleIcon from "assets/svg/googleIcon";
import EmailIcon from "assets/svg/EmailIcon";
import { useGoogleLogin } from "@react-oauth/google";
import { trackEvent } from "../../../firebase";

const SignInForm = (props) => {
  const { className, signUpUrl = appConfig.signUpPath } = props;
  const themeColor = useSelector((state) => state?.theme?.themeColor);
  const primaryColorLevel = useSelector(
    (state) => state?.theme?.primaryColorLevel
  );

  const navigate = useNavigate();
  const { token } = useSelector((state) => state?.auth?.session);
  const { userData } = useSelector((state) => state?.auth?.user);
  const [mobile_no, setMobile_no] = useState("");
  const { signIn, signInWithEmailOtp } = useAuth();
  const [error, setError] = useState("");
  const [errorOtp, setErrorOtp] = useState("");
  const [otp, setOtp] = useState("");
  const [result, setResult] = useState("");
  const { setUpRecaptha, resendOTP } = useUserAuth();
  const [flag, setFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const [verifLoader, setVerifLoader] = useState(false);
  const [buttonEnabled, setButtonEnabled] = useState(false);
  // Email → OTP flow state
  const [isEmailLogin, setIsEmailLogin] = useState(false);
  const [emailStep, setEmailStep] = useState("enter"); // 'enter' | 'otp'
  const [email, setEmail] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [silentLoading, setSilentLoading] = useState(false);
  const silentLoginTriggered = useRef(false);

  // Read plan and period from URL and store in localStorage
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const rawPlan = params.get("plan");
      const rawPeriod = params.get("period");

      const allowedPlans = ["Free", "Pro", "Studio"];
      const normalizePlan = (val) => {
        if (!val) return null;
        const cap = String(val).trim().toLowerCase();
        const planCap = cap.charAt(0).toUpperCase() + cap.slice(1);
        return allowedPlans.includes(planCap) ? planCap : null;
      };

      const normalizePeriod = (val) => {
        if (!val) return null;
        const p = String(val).trim().toLowerCase();
        if (p === "yearly" || p === "annual") return "yearly";
        if (p === "monthly" || p === "month") return "monthly";
        return null;
      };

      const plan = normalizePlan(rawPlan);
      const period = normalizePeriod(rawPeriod);

      if (plan) {
        localStorage.setItem("selectedPlanFromUrl", plan);
      }
      if (period) {
        localStorage.setItem("planPeriodFromUrl", period);
      }
    } catch (_) { }
  }, []);

  useEffect(() => {
    if (token && userData) {
      // Check user role from userData to determine navigation
      const userRole = userData?.authority?.[0] || "client";
      const navigationPath =
        userRole === "freelancer"
          ? appConfig.freelancerEntryPath
          : appConfig.welcomeEntryPath;

      navigate(navigationPath);
    }
  }, [token, userData, navigate]);

  // Handle silent token authentication
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const silentToken = params.get("token");

    if (silentToken && !token && !silentLoginTriggered.current) {
      const performSilentLogin = async () => {
        try {
          silentLoginTriggered.current = true;
          setSilentLoading(true);
          // Call the API with the token (similar to GetFreelancerData)
          const response = await axiosInstance.get(`/app/v1/auth/get-freelancer-data?token=${silentToken}`);
          
          if (response?.status) {
            // Logic for auto-login using the same verify OTP response flow
            const result = await signInWithEmailOtp(response, silentToken);
            
            if (result.status === "success") {
              openNotification("success", "Auto login successful");
              // useAuth will handle navigation to profile via its internal useEffect
            } else {
              openNotification("danger", result.message || "Auto login failed");
              setSilentLoading(false);
            }
          } else {
            openNotification("danger", response?.message || "Failed to fetch freelancer data");
            setSilentLoading(false);
          }
        } catch (error) {
          console.error("Auto login error:", error);
          openNotification("danger", error?.response?.data?.message || "An error occurred during auto login");
          setSilentLoading(false);
        }
      };

      performSilentLogin();
    }
  }, [signInWithEmailOtp]);
  const CheckClient = async (phone_no) => {
    try {
      let formData = new FormData();
      formData.append("phone_no", phone_no);
      const response = await axiosInstance.post(
        `client/auth/check-client`,
        formData
      );
      return response;
    } catch (error) {
      console.log("CheckClient error : ", error.message);

      // Extract error message from backend response
      let errorMessage = "Something went wrong";

      if (error?.response?.data?.message) {
        // Backend sent a specific error message
        errorMessage = error.response.data.message;
      } else if (error?.response?.status === 400) {
        // Handle 400 errors specifically
        errorMessage =
          error?.response?.data?.message ||
          "Invalid phone number. Please check your credentials.";
      } else if (error?.message) {
        // Fallback to axios error message
        errorMessage = error.message;
      }

      openNotification("danger", errorMessage);
      return { status: false, message: errorMessage };
    }
  };
  const getOtp = async (e) => {
    e.preventDefault();
    setError("");

    if (
      mobile_no === "" ||
      mobile_no === undefined ||
      !isValidPhoneNumber(mobile_no)
    ) {
      return setError("Please enter a valid phone number!");
    }

    setLoader(true);

    const accessStatus = await CheckClient(mobile_no);
    if (accessStatus && accessStatus.status) {
      try {
        await signIn({ mobile_no });
        openNotification("success", "Signed in successfully");
        trackEvent('trainer_login', {
          method: 'mobile_no',
          phone: mobile_no
        });

        // Get user role from response to determine navigation
        const userRole = accessStatus.data?.role
          ? String(accessStatus.data.role).toLowerCase()
          : "client";
        const navigationPath =
          userRole === "freelancer"
            ? appConfig.freelancerEntryPath
            : appConfig.welcomeEntryPath;

        navigate(navigationPath);
      } catch (err) {
        console.log("signIn error: ", err.message);
        openNotification("danger", "Sign in failed");
        setError(err.message);
      }
    } else {
      setError(
        accessStatus.status === false ? accessStatus.message : accessStatus
      );
    }

    setLoader(false);
  };

  const resendOtp = async (e) => {
    // e.preventDefault();

    try {
      setError("");
      setResult("");
      setOtp("");
      const response = await resendOTP(mobile_no);
      setResult(response);
      openNotification("success", "OTP Resend Successfully");
    } catch (err) {
      // Extract error message from backend response
      let errorMessage = "OTP Not Sent";

      if (err?.response?.data?.message) {
        // Backend sent a specific error message
        errorMessage = err.response.data.message;
      } else if (err?.response?.status === 400) {
        // Handle 400 errors specifically
        errorMessage =
          err?.response?.data?.message ||
          "Failed to resend OTP. Please try again.";
      } else if (err?.message) {
        // Fallback to axios error message
        errorMessage = err.message;
      }

      setError(errorMessage);
      console.log("resendOtp error: ", err.message);
      openNotification("danger", errorMessage);
    }
  };

  // ========= Email login flow =========
  const requestEmailOtp = async () => {
    try {
      setEmailError("");
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setEmailError("Please enter a valid email address");
        return;
      }
      setEmailLoading(true);
      const response = await axiosInstance.post(
        `/app/v1/auth/send-otp`,
        {
          email,
          isFromWeb: true,
          isSignUp: false
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      if (response?.status) {
        openNotification(
          "success",
          response?.message || "OTP sent to your email"
        );
        setEmailStep("otp");
      } else {
        setEmailError(response?.message || "Failed to send OTP");
        openNotification("danger", response?.message || "Failed to send OTP");
      }
    } catch (err) {
      // Extract error message from backend response
      let errorMessage = "Something went wrong";

      if (err?.response?.data?.message) {
        // Backend sent a specific error message
        errorMessage = err.response.data.message;
      } else if (err?.response?.status === 400) {
        // Handle 400 errors specifically
        errorMessage =
          err?.response?.data?.message ||
          "Invalid request. Please check your email.";
      } else if (err?.message) {
        // Fallback to axios error message
        errorMessage = err.message;
      }

      setEmailError(errorMessage);
      openNotification("danger", errorMessage);
    } finally {
      setEmailLoading(false);
    }
  };

  const verifyEmailOtp = async () => {
    try {
      setEmailError("");
      if (!emailOtp || emailOtp.length < 4) {
        setEmailError("Please enter the OTP sent to your email");
        return;
      }
      setEmailLoading(true);
      const response = await axiosInstance.post(
        `/app/v1/auth/verify-otp`,
        {
          email,
          otp: Number(emailOtp),
          device_token: "",
          isFromWeb: true,
          isSignUp: false,
          role: "gymOwner"
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      if (response?.status) {
        console.log("response otp", response);
        // Bootstrap local session + user from verify response
        await signInWithEmailOtp(response);
        openNotification(
          "success",
          response?.message || "Signed in successfully"
        );
        trackEvent('trainer_login', {
          method: 'email_otp',
          email: email
        });
      } else {
        setEmailError(response?.message || "Invalid OTP");
        openNotification("danger", response?.message || "Invalid OTP");
      }
    } catch (err) {
      // Extract error message from backend response
      let errorMessage = "Verification failed";

      if (err?.response?.data?.message) {
        // Backend sent a specific error message
        errorMessage = err.response.data.message;
      } else if (err?.response?.status === 400) {
        // Handle 400 errors specifically
        errorMessage =
          err?.response?.data?.message ||
          "Invalid credentials. Please check your OTP.";
      } else if (err?.message) {
        // Fallback to axios error message
        errorMessage = err.message;
      }

      setEmailError(errorMessage);
      openNotification("danger", errorMessage);
    } finally {
      setEmailLoading(false);
    }
  };
  // Local Submit
  const verifyOtp = async () => {
    if (otp === "" || otp === null) return;
    try {
      setVerifLoader(true);
      setErrorOtp("");
      await result.confirm(otp);
      let formData = new FormData();
      formData.append("phone_no", mobile_no);
      signIn({ mobile_no });
      setVerifLoader(false);
    } catch (err) {
      console.log("verifyOtp error: ", err.message);
      if (err.message.includes(`auth/invalid-verification-code`)) {
        setErrorOtp("Incorrect OTP Provided");
        setVerifLoader(false);
      } else {
        setVerifLoader(false);
        setErrorOtp(err.message);
      }
    }
  };

  // const login = useGoogleLogin({
  //   onSuccess: async (codeResponse) => {
  //     // console.log("Auth Code Response:", codeResponse);
  //     console.log("start 1");

  //     try {
  //       console.log("start 2");
  //       const res = await fetch("https://oauth2.googleapis.com/token", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           code: codeResponse.code,
  //           client_id:
  //             "759363754072-aqi8ifh2827mu7ctgu9js77t87i6s4ic.apps.googleusercontent.com",
  //           client_secret: "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",
  //           redirect_uri: "http://localhost:3000",
  //           // "https://trainerx-dev.firebaseapp.com/__/auth/handler",
  //           grant_type: "authorization_code",
  //         }),
  //       });
  //       console.log("goggle res", res);
  //       const tokenData = await res.json();
  //       // console.log("Token Response:", tokenData);
  //       console.log("end");

  //       if (tokenData.access_token) {
  //         const res = await signIn({
  //           idToken: tokenData.id_token,
  //         });
  //         console.log("res", res);
  //         // if (isStatusInclude(res?.data?.status)) {
  //         //   localStorage.setItem("token", res?.data?.accessToken);
  //         //   localStorage.setItem("refreshToken", res?.data?.refreshToken);
  //         //   localStorage.setItem("userId", res?.data?.userId);
  //         //   localStorage.setItem("sessionId", res?.data?.sessionId);
  //         //   localStorage.setItem(
  //         //     "trialExpireDate",
  //         //     res?.data?.organization?.trialExpireDate
  //         //   );
  //         //   localStorage.setItem("session", JSON.stringify(res?.data));
  //         //   if (res?.data?.user?.role === "superAdmin") {
  //         //     redirect("/superadmin/dashboard");
  //         //   } else {
  //         //     redirect("/admin/dashboard");
  //         //   }
  //         // }
  //       }
  //     } catch (error) {
  //       console.error("Error exchanging code for token:", error);
  //     }
  //   },
  //   flow: "auth-code",
  // });

  const login = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      console.log("start 1", codeResponse);
      try {
        console.log("start 2");

        const res = await fetch("https://oauth2.googleapis.com/token", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            code: codeResponse.code,
            client_id:
              "759363754072-aqi8ifh2827mu7ctgu9js77t87i6s4ic.apps.googleusercontent.com",
            client_secret: "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",
            redirect_uri: "https://portal.trainerx.co",
            // redirect_uri: "https://trainerx.kmsoft.org",
            // redirect_uri: "http://localhost:3001",
            grant_type: "authorization_code",
          }),
        });
        // redirect_uri: "http://localhost:3000",

        // "https://trainerx-dev.firebaseapp.com/__/auth/handler",

        const tokenData = await res.json();
        console.log("Token data:", tokenData);

        if (tokenData.access_token) {
          const res = await signIn({
            idToken: tokenData.id_token,
            isSignUp: false,
            role: "gymOwner"
          });

          console.log("error <><><>", res?.message);

          if (res?.message) {
            openNotification("danger", res?.message || "Google login failed");
          } else {
            trackEvent('trainer_login', {
              method: 'google'
            });
            openNotification("success", "Signed in successfully with Google");
          }
        }
      } catch (error) {
        console.error("Token exchange failed:", error);
      }
    },
    flow: "auth-code",
  });
  // const login = useGoogleLogin({
  //   flow: "implicit", // change from "auth-code" to "implicit"
  //   scope: "openid email profile",
  //   onSuccess: async (tokenResponse) => {
  //     console.log("Login success:", tokenResponse);

  //     try {
  //       if (tokenResponse?.access_token) {
  //         const res = await fetch(
  //           `https://www.googleapis.com/oauth2/v3/userinfo`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${tokenResponse.access_token}`,
  //             },
  //           }
  //         );
  //         const profile = await res.json();
  //         console.log("User profile:", profile);

  //         const signInResponse = await signIn({
  //           idToken: tokenResponse.id_token,
  //         });
  //         console.log("Backend signIn response:", signInResponse);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching user profile:", error);
  //     }
  //   },
  //   onError: (error) => {
  //     console.error("Google login failed:", error);
  //   },
  // });

  // const login = useGoogleLogin({
  //   flow: "auth-code",
  //   scope: "openid email profile",
  //   onSuccess: async (codeResponse) => {
  //     console.log("Login success:", codeResponse);

  //     try {
  //       const res = await fetch("https://oauth2.googleapis.com/token", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           code: codeResponse.code,
  //           client_id:"759363754072-aqi8ifh2827mu7ctgu9js77t87i6s4ic.apps.googleusercontent.com",
  //           client_secret: "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",
  //           redirect_uri: "http://localhost:3000/oauth2callback",
  //           grant_type: "authorization_code",
  //         }),
  //       });

  //       const tokenData = await res.json();
  //       console.log("Google token response:", tokenData);

  //       if (tokenData?.id_token) {
  //         const signInResponse = await signIn({ idToken: tokenData.id_token });
  //         console.log("Backend signIn response:", signInResponse);
  //       }
  //     } catch (error) {
  //       console.error("Error during token exchange:", error);
  //     }
  //   },
  //   onError: (error) => {
  //     console.error("Google login failed:", error);
  //   },
  // });

  // const onSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const res = await fetch("https://oauth2.googleapis.com/token", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         code: codeResponse.code,
  //         client_id:
  //           "759363754072-aqi8ifh2827mu7ctgu9js77t87i6s4ic.apps.googleusercontent.com",
  //         client_secret: "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",
  //         redirect_uri: "https://trainerx-dev.firebaseapp.com/__/auth/handler",
  //         grant_type: "authorization_code",
  //       }),
  //     });

  //     const tokenData = await res.json();
  //     // console.log("Token Response:", tokenData);

  //     if (tokenData.access_token) {
  //       signIn({
  //         idToken: tokenData.id_token,
  //       });
  //     }
  //   } catch (error) {
  //     setVerifLoader(true);
  //     console.log("onSubmit error :", error.message);
  //   }
  // };

  useEffect(() => {
    if (otp && otp?.length >= 6) {
      setButtonEnabled(true);
    } else {
      setButtonEnabled(false);
    }
  }, [otp]);
  return (
    <>
      {silentLoading ? (
        <div className="flex flex-col items-center justify-center min-h-[300px] gap-4">
          <div className="w-10 h-10 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
          <div className="text-center">
            <h3 className="text-xl font-semibold mb-1">Authenticating...</h3>
            <p className="text-gray-500">Redirecting to your profile...</p>
          </div>
        </div>
      ) : (
        <div className={className}>
        {/* ── Email OTP verification step ── */}
        {emailStep === "otp" ? (
          <div className="mt-2">
            <div className="mb-6 text-left">
              <h3
                className={`mb-2 font-bold text-${themeColor}-${primaryColorLevel}`}
              >
                Verify your Email
              </h3>
              <p className="text-gray-500 text-sm">
                Enter the 6-digit code sent to{" "}
                <span className="font-semibold text-gray-700">{email}</span>
              </p>
            </div>

            {emailError && (
              <Alert
                className="mb-4"
                type="danger"
                duration={3000}
                onClose={() => setEmailError("")}
                showIcon
              >
                {emailError}
              </Alert>
            )}

            <div className="flex justify-center mb-4">
              <OtpInput
                value={emailOtp}
                onChange={setEmailOtp}
                inputStyle="inputStyle"
                numInputs={6}
                separator={<span></span>}
                inputType={"number"}
                renderInput={(props) => <input {...props} />}
              />
            </div>

            <div className="flex justify-end mb-4">
              <button
                type="button"
                onClick={() => setEmailStep("enter")}
                className="text-sm text-gray-600 hover:underline"
              >
                Edit Email
              </button>
            </div>

            <Button
              block
              loading={emailLoading}
              variant="solid"
              onClick={verifyEmailOtp}
            >
              {emailLoading ? "Verifying..." : "Verify Email"}
            </Button>
          </div>
        ) : (
          /* ── Main login view ── */
          <>
            {/* Header */}
            <div className="mb-4 text-center">
              <h3
                className={`mb-1 font-bold text-lg text-${themeColor}-${primaryColorLevel}`}
              >
                Try TrainerX for 30 Days
              </h3>
              <p className="text-gray-500 text-sm">No credit card required.</p>
            </div>

            {/* Login heading */}
            <h4 className={`font-bold text-${themeColor}-${primaryColorLevel} text-xl mb-5 text-center`}>
              Login
            </h4>

            {/* Error alert */}
            {emailError && (
              <Alert
                className="mb-4"
                type="danger"
                duration={3000}
                onClose={() => setEmailError("")}
                showIcon
              >
                {emailError}
              </Alert>
            )}

            {/* Email input */}
            <div className="mb-4 text-left">
              <label className="block text-sm text-gray-700 mb-2">
                Enter your mail address{" "}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="test@gmail.com"
                onKeyDown={(e) => e.key === "Enter" && requestEmailOtp()}
                className={`w-full px-4 py-3 rounded-lg border border-gray-300 outline-none focus:ring-2 focus:ring-${themeColor}-${primaryColorLevel} text-sm transition-all`}
              />
            </div>

            {/* Continue with Email button */}
            <Button
              block
              loading={emailLoading}
              variant="solid"
              onClick={requestEmailOtp}
              className="mb-4"
            >
              {emailLoading ? "Sending..." : "Continue with Email"}
            </Button>

            {/* Or divider */}
            <div className="flex items-center my-4">
              <div className="flex-grow border-t border-gray-300"></div>
              <span className="mx-4 text-gray-500 text-sm">Or</span>
              <div className="flex-grow border-t border-gray-300"></div>
            </div>

            {/* Continue with Google button */}
            <button
              type="button"
              onClick={() => login()}
              className="w-full border border-gray-300 rounded-lg py-3 text-sm font-medium flex justify-center items-center gap-3 hover:bg-gray-50 transition-colors bg-white mb-4"
            >
              <GoogleIcon />
              Continue with google
            </button>

            {/* Create account link */}
            <div className="mt-2 text-center text-sm text-gray-600">
              Don't have account yet?{" "}
              <Link
                to={signUpUrl}
                className={`text-${themeColor}-${primaryColorLevel} font-semibold hover:underline`}
              >
                Create account
              </Link>
            </div>
          </>
        )}
        </div>
      )}
    </>
  );
};

export default SignInForm;
